(ns ycweb.app.website.dlp.widgets.specials
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cards :as cards]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]))

(rum/defc specials < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:specials/keys
         [title heading-type on-page-link-id columns
          show-viewmore-link? more-url products
          custom-viewmore-text custom-viewmore-link
          section-size heading-size]} properties]

    (when-not (empty? products)
      [:div
       {:id (when on-page-link-id on-page-link-id)
        :class
        (str "yc-section"
          (when (u/presence section-size) (str " yc-section--" section-size))
          (when (u/presence section-size) " card-section"))}
       (when title
         (headings/heading title
           {:type (keyword (str "h" heading-type))
            :size (or (keyword (u/presence heading-size)) :default)
            :dangerouslySetInnerHTML? true}))

       (cond
         (= columns 6)
         [:div
          {:class (u/bem :flex-grid-group [:align-left])}
          (map
            (fn [product]
              [:div
               {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 :l-1-6])}
               (cards/product-card-default app-atom product {:small? true})])
            products)

          (when show-viewmore-link?
            [:div
             {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 :l-1-6])}
             (cards/more-card
               {:url
                (if (u/presence custom-viewmore-link)
                  custom-viewmore-link
                  more-url)
                :text custom-viewmore-text})])]

         :else
         [:div
          {:class (u/bem :flex-grid-group [:small :align-left])}
          (map
            (fn [product]
              [:div
               {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 (keyword (str "l-1-" columns))])}
               (cards/product-card-default app-atom product {})])
            products)])

       (when (and (< columns 6) show-viewmore-link?)
         [:div.u-margin-top-16
          {:class (u/bem :flex-grid-group [:m-align-right])}
          [:div.u-min-width-240
           {:class (u/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (buttons/button-web "View more"
              {:type :button
               :href more-url
               :full true
               :icon :arrow-right
               :icon-placement :right})]]])])))
